export default __webpack_public_path__ + "static/media/paymentMetod.8bcb9032.webp";